export function pwaPlatform(userAgent = '', maxTouchPoints = 0) {
  const isIOS = /iphone|ipad|ipod/i.test(userAgent) || (/macintosh/i.test(userAgent) && maxTouchPoints > 1)
  const isAndroid = /android/i.test(userAgent)
  const isInApp = /zalo|fban|fbav|instagram|line\/|; wv\)/i.test(userAgent)
  return { isIOS, isAndroid, isInApp }
}
